import React from 'react';

import { makeClassNames } from '../../../utils/styles';
import './spacer.scss';

export type Spaces = 10 | 20 | 30 | 60;

export interface ISpacer {
  size: Spaces;
}

const classNames = (size: Spaces) =>
  makeClassNames({
    spacer: `spacer--${size}`,
  });

const Spacer = ({ size }: ISpacer) => {
  const cn = classNames(size);
  return <div className={cn.spacer} />;
};

export default Spacer;
